import { Scroller } from './animations';
import { Page } from './shared';
import gsap from '@gsap/business';
import { ScrollTrigger } from '@gsap/business/ScrollTrigger';
import {LazyLoad} from './shared/';
import ModuleLoader from './modules/module.loader.js';
import {LAZYMODULES} from './app.config.js';

gsap.registerPlugin(ScrollTrigger);

//css

export default class App extends Page {

	constructor(el) {
		super(el);
		this.init();
		this.initAnimations();
	}

	initAnimations() {
		this.scroller = new Scroller();
		this.loadLazyModules();
	}

	loadLazyModules(context) {
		const container = context ? context.container : document.body;
		this.modules = [];
		this.images = [];
		this.modules = ModuleLoader.moduleLoader(container);
		!LAZYMODULES && ModuleLoader.loadAllModules(this.modules, this.onModulesLoaded(container));
		// this.images = new LazyLoad(container, this.onImageLoaded.bind(this));
		this.images = new LazyLoad(container);
	}

	onImageLoaded() {
		//window.client.scroller.refresh();
	}
}

window.onload = () => {
	const app = new App();
};

